/**
 * Extract pass name from ALX summary log filename.
 * Ported from extract_welding_data.py extract_pass_name().
 */
export function extractAlxPassName(filename: string): string | null {
  const name = filename.replace('.txt', '').replace(/ /g, '_')

  const matchConcatenated = /_([A-Z]+)(\d{1,2})_\d{8}/.exec(name)
  if (matchConcatenated) {
    const passType = matchConcatenated[1]
    const passNum = matchConcatenated[2]
    if (passType === 'CAP') return `CAP ${passNum}`
    if (passType.includes('FILL')) return `Fill ${passNum}`
    const formatted = passType.length > 1 ? capitalize(passType) : passType
    return `${formatted} ${passNum}`
  }

  const matchWithNumAndSuffix = /_([A-Z]+)_(\d{1,2})_[A-Z_]*\d{8}/.exec(name)
  if (matchWithNumAndSuffix) {
    const passType = matchWithNumAndSuffix[1]
    const passNum = matchWithNumAndSuffix[2]
    if (passType.includes('FILL') || passType === 'SINGLEPASSFILL') return `Fill ${passNum}`
    if (passType === 'CAP') return `CAP ${passNum}`
    const formatted = passType.length > 1 ? capitalize(passType) : passType
    return `${formatted} ${passNum}`
  }

  const matchSuffixWithNum = /_([A-Z]+)_[A-Z]+_(\d{1,2})_\d{8}/.exec(name)
  if (matchSuffixWithNum) {
    const passType = matchSuffixWithNum[1]
    const passNum = matchSuffixWithNum[2]
    if (passType.includes('FILL') || passType === 'SINGLEPASSFILL') return `Fill ${passNum}`
    if (passType === 'CAP') return `CAP ${passNum}`
    const formatted = passType.length > 1 ? capitalize(passType) : passType
    return `${formatted} ${passNum}`
  }

  const matchWithNum = /_([A-Z]+)_(\d{1,2})_\d{8}/.exec(name)
  if (matchWithNum) {
    const passType = matchWithNum[1]
    const passNum = matchWithNum[2]
    if (passType.includes('FILL') || passType === 'SINGLEPASSFILL') return `Fill ${passNum}`
    if (passType === 'CAP') return `CAP ${passNum}`
    const formatted = passType.length > 1 ? capitalize(passType) : passType
    return `${formatted} ${passNum}`
  }

  const matchWithSuffix = /_([A-Z]+)_([A-Z]+)_\d{8}/.exec(name)
  if (matchWithSuffix) {
    const passType = matchWithSuffix[1]
    const suffix = matchWithSuffix[2]
    if (passType === 'HOTPASS') return `HOT ${suffix}`
    const formattedType = passType.length > 1 ? capitalize(passType) : passType
    const formattedSuffix = suffix.length > 1 ? capitalize(suffix) : suffix
    return `${formattedType} ${formattedSuffix}`
  }

  const matchWithoutNum = /_([A-Z]+)_\d{8}/.exec(name)
  if (matchWithoutNum) {
    const passType = matchWithoutNum[1]
    if (passType === 'ROOT') return 'ROOT'
    if (passType === 'HOTPASS') return 'HOT'
    if (passType === 'CAP') return 'CAP 1'
    return passType.length > 1 ? capitalize(passType) : passType
  }

  return null
}

function capitalize(value: string): string {
  return value.charAt(0) + value.slice(1).toLowerCase()
}
